import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/AppContextProvider";
import { ErrorDisplay } from "../../shared/components/Error";
import { Link, useNavigate } from "react-router-dom";
import { type OrgReducerInterface } from "../../context/reducers/orgnization";
import { SET_CURRENT_ORG } from "../../context/actions/ActionTypes";
import { withWorkspaceId } from "shared/utils/workspaceRouting";
export const Organization = (): JSX.Element => {
  const { t } = useTranslation();
  const context = useContext(GlobalContext);
  const { orgDispatch, orgState } = context;
  const navigate = useNavigate();
  const { orgs } = orgState as OrgReducerInterface;

  useEffect(() => {
    const selectedOrgId = localStorage.getItem("OrganizationId");
    const fetchOrgsAndFindSelected = async (): Promise<void> => {
      if (selectedOrgId) {
        const selectedOrg = orgs.find((org) => org.id === selectedOrgId);
        if (selectedOrg) {
          orgDispatch({ type: SET_CURRENT_ORG, payload: selectedOrg });
          navigate(
            withWorkspaceId(`/app/organization/${selectedOrgId}/assessments`)
          );
        }
      }
    };
    void fetchOrgsAndFindSelected();
  }, [orgs]);
  return (
    <ErrorDisplay
      title={t("No Organization selected")}
      subTitle={t(
        "In order to create a custom assessment,\n you have to select an organization"
      )}
      cardClassName="custom-card"
    >
      <Link to="/my-cropwise">{t("My Cropwise")}</Link>
    </ErrorDisplay>
  );
};
